const defaultState = {
    pending: [],
    appointments: [],
    closed: [],
    denied: [],
    abandoned: []
}

const requestNewestReducer = (state = defaultState, action) => {
    switch (action.type) {
        case 'SET_NEWEST_REQUESTS':
            return {
                ...state,
                pending: action.payload.filter(r => r.status === 0),
                appointments: action.payload.filter(r => r.status === 1),
                closed: action.payload.filter(r => r.status === 2),
                denied: action.payload.filter(r => r.status === 4),
                abandoned: action.payload.filter(r => r.status === 3),
            }
        case 'UNSET_NEWEST_REQUESTS':
            return defaultState;
        default:
            return state;
    }
};

export default requestNewestReducer;